import { Component } from '@angular/core';
import 'hammerjs';
import { TitleService } from '../shared/services/title.service';

@Component({
  selector: 'e2cb-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})

export class LandingComponent {
  constructor(private _titleService: TitleService) {
    _titleService.Subtitle = 'Client Billing Home';
  }
}
